<template>
  <div>
    <div
      class="is-flex is-flex-wrap-wrap is-justify-content-space-between is-align-items-center is-flex-direction-column-mobile is-flex-direction-row"
    >
      <strong class="mb-2 mr-4"
        >Campos marcados com * são considerados obrigatórios</strong
      >
      <div
        v-if="hasPermitionToActivate() && $route.params.id"
        class="mb-2 mr-4"
      >
        <strong>Status:</strong>
        <StatusTag :status="form.status" class="ml-2" />
      </div>
      <div
        v-if="hasPermitionToActivate() && $route.params.id"
        class="is-flex is-align-items-center mb-2"
      >
        <b-switch v-model="ativo" @input="switchActiveStatus" class="mr-2"
          >Ativo</b-switch
        >
        <ApproveOrRefuseGroupButtons
          v-if="hasPermitionToApprove()"
          @refuse="(payload) => recusar(payload)"
          @approve="aprovar"
        />
      </div>
    </div>

    <hr />

    <!-- Áreas Permitidas -->
    <b-field label="Áreas Permitidas*">
      <div class="buttons has-addons">
        <b-checkbox v-model="form.areaPrimaria">Área Primária</b-checkbox>
        <b-checkbox v-model="form.areaSecundaria" :disabled="form.areaPrimaria"
          >Área Secundária</b-checkbox
        >
      </div>
    </b-field>

    <!-- Empresa e Tipo de Pessoa -->
    <b-field grouped>
      <b-field label="Empresa*" expanded>
        <SelectEmpresa
        @empresaSelecionada="(empresaSelecionada) => (form.empresaId = empresaSelecionada.id)"
        :selected="form.empresaId"
        :disabled="$route.params.id"
        />
      </b-field>
      <b-field label="Tipo Pessoa*" expanded>
        <b-select v-model="form.tipo" expanded :disabled="$route.params.id" @input="handlePersonTypeChange">
          <option value="VISITANTE">Visitante</option>
          <option value="FUNCIONARIO">Funcionário</option>
        </b-select>
      </b-field>
      <b-field label="Estrangeiro*" expanded>
        <b-select v-model="form.estrangeiro" expanded>
          <option :value="true">Sim</option>
          <option :value="false">Não</option>
        </b-select>
      </b-field>
    </b-field>

    <!-- Nome, Documento, RG, CNH -->
    <b-field grouped class="is-flex is-flex-wrap-wrap">
      <b-field label="Documento ( CPF | Passaporte ) *" expanded>
        <b-input
          v-model="form.documento"
          required
          v-mask="form.estrangeiro ? '' : '###.###.###-##'"
        ></b-input>
      </b-field>

      <b-field label="Nome*" expanded>
        <b-input v-model="form.nome" required></b-input>
      </b-field>

      <b-field label="Telefone" expanded>
        <b-input
          v-model="form.telefone"
          v-mask="telefoneMask"
          required
        ></b-input>
      </b-field>
    </b-field>

    <b-field grouped class="is-flex is-flex-wrap-wrap">
      <b-field label="RG" expanded>
        <b-input v-model="form.rg"></b-input>
      </b-field>

      <b-field label="CNH" expanded>
        <b-input v-model="form.cnh"></b-input>
      </b-field>

      <b-field label="Validade CNH" expanded>
        <b-datepicker
          v-model="form.validadeCnh"
          placeholder="Selecione uma data"
        ></b-datepicker>
      </b-field>
    </b-field>

    <!-- Data Início e Data Fim -->
    <div v-if="form.tipo == 'VISITANTE'">
      <b-field grouped>
        <b-field label="Data Início*" expanded>
          <b-datepicker
            v-model="form.dataInicio"
            placeholder="Selecione uma data"
          ></b-datepicker>
        </b-field>

        <b-field label="Data Fim*" expanded>
          <b-datepicker
            v-model="form.dataFim"
            placeholder="Selecione uma data"
          ></b-datepicker>
        </b-field>
      </b-field>

      <b-field>
        <!-- Justificativa -->
        <b-field label="Justificativa">
          <b-input
            type="textarea"
            v-model="form.justificativa"
            maxlength="150"
            placeholder="Justificativa para visitante"
            :disabled="form.tipo !== 'VISITANTE'"
          ></b-input>
        </b-field>
      </b-field>
    </div>
    <div class="is-flex is-justify-content-center">
      <b-button type="is-primary" @click="formAction">{{
        this.$route.params.id ? "Atualizar" : (form.tipo != 'VISITANTE' ? 'Próximo' : 'Enviar')
      }}</b-button>
    </div>
  </div>
</template>

<script>
import AcessosService from "@/services/AcessosService";
import Util from "@/services/Util";

import SelectEmpresa from "../Selects/SelectEmpresa.vue";
import CardComponent from "../Cards/CardComponent.vue";
import ApproveOrRefuseGroupButtons from "../ApproveOrRefuseGroupButtons.vue";
import StatusTag from "../StatusTag.vue";

export default {
  name: "FormAcessoPessoa",
  components: {
    SelectEmpresa,
    CardComponent,
    ApproveOrRefuseGroupButtons,
    StatusTag,
  },
  data() {
    return {
      form: {
        tipo: null,
        estrangeiro: false,
        nome: "",
        documento: "",
        rg: "",
        cnh: "",
        validadeCnh: null,
        justificativa: "",
        dataInicio: null,
        dataFim: null,
        empresaId: null,
        areaPrimaria: false,
        areaSecundaria: false,
        status: null,
        telefone: "",
      },
      ativo: null,
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.getAcesso(this.$route.params.id);
    }
  },
  watch: {
    "form.areaPrimaria"(newValue) {
      if (newValue === true) {
        this.form.areaSecundaria = true;
      } else {
        this.form.areaSecundaria = false;
      }
    },
  },
  methods: {
    async aprovar() {
      try {
        await AcessosService.setStatusAcessoPessoa(
          this.$route.params.id,
          "ATIVO"
        );
        this.$buefy.toast.open({
          message: `Acesso Aprovado com sucesso!`,
          position: "is-bottom",
          type: "is-info",
        });
        window.location.reload();
      } catch (error) {
        this.$buefy.toast.open({
          message: error.response.data.message,
          position: "is-bottom",
          type: "is-danger",
        });
      }
    },
    async recusar(payload) {
      try {
        const { id, motivoRecusa } = payload;
        await AcessosService.setRecusarAcessoPessoa(id, motivoRecusa);
        this.$buefy.toast.open({
          message: `Acesso Recusado com sucesso!`,
          position: "is-bottom",
          type: "is-info",
        });
        window.location.reload();
      } catch (error) {
        this.$buefy.toast.open({
          message: error.response.data.message,
          position: "is-bottom",
          type: "is-danger",
        });
      }
    },
    hasPermitionToApprove() {
      return Util.isAdmin();
    },
    hasPermitionToActivate() {
      return Util.isAdmin() || Util.isCadastro();
    },
    async switchActiveStatus() {
      try {
        const payload = {
          status: this.ativo ? "ATIVO" : "INATIVO",
        };
        const res = this.ativo
          ? await AcessosService.setStatusAcessoPessoa(
              this.$route.params.id,
              payload.status
            )
          : await AcessosService.setStatusAcessoPessoaInativo(
              this.$route.params.id
            );
        this.$buefy.toast.open({
          message: `Status atualizado para ${this.ativo ? "ATIVO" : "INATIVO"}`,
          position: "is-bottom",
          type: "is-success",
        });
        window.location.reload();
      } catch (error) {
        console.log(error);
        this.$buefy.toast.open({
          message: error.response.data.message,
          position: "is-bottom",
          type: "is-danger",
        });
      }
    },
    empresaSelecionada(empresa) {
      this.form.empresaId = empresa;
    },
    async getAcesso(id) {
      try {
        const res = await AcessosService.getAcessoPessoa(id);
        Object.assign(this.form, {
          ...res.data,
          empresaId: res.data.empresa?.id ?? null,
          nome: res.data.pessoa?.nome ?? "",
          documento: res.data.pessoa?.cpf ?? res.data.pessoa?.passaporte ?? "",
          rg: res.data.pessoa?.rg ?? "",
          cnh: res.data.pessoa?.cnh ?? "",
          status: res.data.status ?? null,
          estrangeiro: res.data.pessoa?.estrangeiro ?? null,
          validadeCnh: res.data.pessoa?.validadeCnh
            ? new Date(res.data.pessoa.validadeCnh)
            : null,
          dataInicio: res.data.dataInicio
            ? new Date(res.data.dataInicio)
            : null,
          dataFim: res.data.dataFim ? new Date(res.data.dataFim) : null,
        });
        this.ativo = this.form.status === "ATIVO";
        this.isInitialized = true; // só aqui liberamos o watcher
      } catch (error) {
        console.error("Erro ao buscar acesso:", error);
        this.$buefy.toast.open({
          message: error.response.data.message,
          position: "is-bottom",
          type: "is-danger",
        });
      }
    },
    formAction() {
      if (this.$route.params.id) {
        this.updateAcessoPessoa();
      } else {
        this.createAcessoPessoa();
      }
    },
    async createAcessoPessoa() {
      try {
        const res = await AcessosService.createAcessoPessoa(this.form);
        this.$buefy.toast.open({
          message: "Acesso criado com sucesso",
          position: "is-bottom",
          type: "is-success",
        });
        if (this.form.tipo === "VISITANTE") {
          this.$router.push("/acessos/pessoas");
        } else {
          this.$router
            .push(`/acessos/editar/pessoa/${res.data.id}`)
            .then(() => {
              window.location.reload(); // Força o reload da página após a navegação
            });
        }
        console.log(res);
      } catch (error) {
        console.log(error);
        this.$buefy.toast.open({
          message: error.response.data.message,
          position: "is-bottom",
          type: "is-danger",
        });
      }
    },
    async updateAcessoPessoa() {
      try {
        const res = await AcessosService.updateAcessoPessoa(
          this.$route.params.id,
          this.form
        );
        this.$buefy.toast.open({
          message: "Atualização realizada com sucesso",
          position: "is-bottom",
          type: "is-success",
        });
        this.$router.push("/acessos/pessoas");
        console.log(res);
      } catch (error) {
        console.log(error);
        this.$buefy.toast.open({
          message: error.response.data.message,
          position: "is-bottom",
          type: "is-danger",
        });
      }
    },
    handlePersonTypeChange(value){
      this.$emit('handlePersonTypeChange', value);
    }
  },
  computed: {
    telefoneMask() {
      const digits = this.form.telefone.replace(/\D/g, "");
      return digits.length > 10 ? "(##) #####-####" : "(##) ####-####";
    },
  },
};
</script>

<style scoped>
.buttons.has-addons {
  display: flex;
  gap: 10px;
}
</style>
